import type { FC } from "react";

import ContainerComponent from "@/components/global/ContainerComponent/ContainerComponent";
import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";

const SkeletonEntryKlubIntroComponent: FC = () => {
  return (
    <ContainerComponent className="flex h-full flex-col items-center gap-[16px] pt-[24px] md:flex-row md:pt-[40px]">
      <Skeleton className="h-[70px] w-[288.36px] flex-none md:h-[98.66px]" />
      <div className="mt-4 flex w-full flex-col items-center justify-center gap-[16px] md:mt-0 md:flex-row">
        <Skeleton className="h-[42px] w-1/2 md:h-12 md:w-full" />
        <Skeleton className="h-10 w-[329.42px] rounded-[50px]" />
      </div>
    </ContainerComponent>
  );
};

export default SkeletonEntryKlubIntroComponent;
